<template>
  <div class="copy-block">
    <div class="copy-block__trigger" @click="copyToClipboard(value)" :class="{ 'is-copied': copied }">
      {{ str }}
    </div>
    <div class="copy-block__informer">{{ $t('Copied') }}</div>
  </div>
</template>

<script>
import { renderAlertVue } from "/webpack-assets/vue/utils/common.js";

export default {
  props: {
    str: {
      type: [String, Number],
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      copied: false
    };
  },
  methods: {
    copyToClipboard(copyData) {
      let tempTextarea = document.createElement('textarea');
      tempTextarea.value = copyData;
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextarea);
      renderAlertVue(this.$t('Copied!'), 'success', 2000)
    }
  }
};
</script>

<style scoped lang="scss">
.copy-block {
  position: relative;
  display: inline-block;
}

.copy-block__trigger {
  cursor: pointer;
}

.copy-block__informer {
  position: absolute;
  right: calc(50% - 15px);
  display: none;
  bottom: calc(100% + 10px);
  padding: 12px 15px;
  background-color: #414d60;
  color: #f6f6f6;
  font-family: "Roboto-Light";
  font-size: 14px;
  line-height: 1.4;
  border-radius: 6px;
  pointer-events: none;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.25);

  &:after {
    content: "";
    position: absolute;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 11px solid #414d60;
    bottom: -10px;
    left: right;
  }
}
</style>